"use client";

import React from "react";
import { useAuth } from "@/providers/auth-provider";
import { NotificationIntegration } from "@/components/shared/notification-integration";

export function NotificationIntegrationWrapper() {
  const { user } = useAuth();
  const userId = user?.id ?? "";

  return <NotificationIntegration userId={userId} />;
}